module.exports = "/img/_/_/_/assets/images/creeper/battle/epic//1.jpg?309782a7959e48fc010a1b245d541058";